"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import classNames from "classnames";
import { usePathname } from "next/navigation";
import { FaBars, FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";

import { useMobileMenu } from "@lib/context/mobile-menu-context";
import MobileMenu from "@modules/mobile-menu/templates";

import LogoImg from "../assets/img/DarkWhiteV2.png";

const collapseItems = [
	{ label: "Hem", link: "/" },
	{ label: "Fordon i lager", link: "/fordon" },
	{ label: "Anläggningar", link: "/anlaggningar" },
	{ label: "Sälj ditt fordon", link: "/salj-ditt-fordon" },
	{ label: "Kontakt", link: "/kontakt" },
	{ label: "Om oss", link: "/om-oss" },
];

export const Logo = () => {
	return (
		<Link href="/">
			<Image width={150} src={LogoImg} alt="VD Motor" priority blurDataURL={LogoImg.blurDataURL} />
		</Link>
	);
};

const HeaderResponsive = () => {
	const { toggle } = useMobileMenu();
	const pathname = usePathname();
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 50);
		};
		window.addEventListener("scroll", handleScroll, { passive: true });
		handleScroll();
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<>
			<header
				className={classNames(
					"fixed top-0 w-full z-40 font-heading transition-all duration-500 ease-out",
					scrolled ? "bg-deep/80 backdrop-blur-xl shadow-lg shadow-black/20" : "bg-transparent"
				)}
			>
				<div className="flex items-center justify-between content-container px-4 2xl:px-0 py-4">
					<div className="flex items-center gap-4">
						<label
							tabIndex={0}
							onClick={() => toggle()}
							className="lg:hidden bg-transparent hover:bg-white/5 p-2 rounded-lg transition-colors cursor-pointer"
						>
							<FaBars />
						</label>
						<Logo />
					</div>
					<div className="hidden lg:flex items-center gap-1">
						{collapseItems.map((item) => (
							<Link
								key={item.link}
								className={classNames(
									"px-5 py-3 uppercase font-semibold cursor-pointer relative bg-transparent",
									"after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:h-[2px] after:bg-accent after:transition-all after:duration-300 after:ease-out",
									pathname === item.link
										? "after:w-3/4 text-white"
										: "after:w-0 hover:after:w-3/4 text-gray-300 hover:text-white"
								)}
								href={item.link}
							>
								{item.label}
							</Link>
						))}
					</div>
					<div className="flex items-center gap-5">
						<Link
							aria-label="Gå till Facebook sida"
							href="https://facebook.com/vdmotor.se"
							target="_blank"
							className="text-gray-300 hover:text-[#1877F2] hover:scale-110 transition-all duration-300"
						>
							<FaFacebook size={22} />
						</Link>
						<Link
							aria-label="Gå till Instagram sida"
							href="https://instagram.com/vdmotorab"
							target="_blank"
							className="text-gray-300 hover:text-[#E4405F] hover:scale-110 transition-all duration-300"
						>
							<FaInstagram size={22} />
						</Link>
						<Link
							aria-label="Gå till TikTok sida"
							href="https://www.tiktok.com/@vdmotor"
							target="_blank"
							className="text-gray-300 hover:text-white hover:scale-110 transition-all duration-300"
						>
							<FaTiktok size={22} />
						</Link>
						{/* <Link
							href="/kontakt"
							className="hidden lg:inline-flex bg-accent hover:bg-accent-hover text-white border-none uppercase text-sm font-semibold tracking-wide px-5 py-2 rounded-lg shadow-md shadow-accent/25 hover:shadow-lg hover:shadow-accent/40 transition-all duration-300"
						>
							Kontakta oss
						</Link> */}
					</div>
				</div>
			</header>
			<MobileMenu />
		</>
	);
};

export default HeaderResponsive;
